import axios from "axios";
//const API_URL = "http://localhost:8080";
const API_URL = "https://api.taurus.rellum.com.ar";

const _fetch = async (endpoint, onSuccess, onFailure, body, method = "get", needAuth = true) => {
  const token = (needAuth && JSON.parse(localStorage.getItem("taurus_user"))?.token) || "";
  const headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };
  const options = {
    method,
    headers,
    url: `${API_URL}${endpoint}`,
    data: body,
  };

  try {
    const response = await axios(options);
    if (response.status >= 200 && response.status < 300) {
      onSuccess(response.data);
    } else {
      onFailure(response);
    }
  } catch (error) {
    onFailure(error.response || error);
  }
};

const authUser = (email, password, onSuccess, onFailure) => {
  _fetch("/user/auth", onSuccess, onFailure, { email, password }, "post", false);
};

const getSelfUser = (onSuccess, onFailure) => {
  _fetch("/user/me", onSuccess, onFailure, null, "get", true);
};

const getMQL4Accounts = (onSuccess, onFailure) => {
  _fetch("/mql4", onSuccess, onFailure, null, "get", false);
};

const getMQL4AccountsProfits = (onSuccess, onFailure) => {
  _fetch("/mql4/profits", onSuccess, onFailure, null, "get", true);
};

const deleteMQL4Account = (accountId, onSuccess, onFailure) => {
  _fetch(`/mql4/${accountId}`, onSuccess, onFailure, {}, "delete", false);
};

const updateMQL4Account = (accountId, data, onSuccess, onFailure) => {
  _fetch(`/mql4/${accountId}`, onSuccess, onFailure, data, "put", false);
};

const updateMQL4Protocol = (protocol, onSuccess, onFailure) => {
  _fetch(`/mql4/protocol`, onSuccess, onFailure, { protocol }, "post", false);
};

const api = {
  authUser,
  getSelfUser,
  getMQL4Accounts,
  deleteMQL4Account,
  updateMQL4Account,
  getMQL4AccountsProfits,
  updateMQL4Protocol,
};

export default api;
